// renders point series
// import ref from './_state';
import moveToFront from './u-move-to-front';
import moveToBack from './u-move-to-back';


export default function (ref, opts) {

    const f = d3.format(',')    

    const data = ref.data

    let hglColour = opts.colour;

    let xKey = opts.xKey;
    let yKey = opts.yKey;

    // create a chart with two linear axes
    let chart = fc.chart.cartesian(
            opts.xScale, // allow for a different scale to be applied on render
            d3.scale.linear()
        )
        .xDomain(fc.util.extent().pad(0.1).fields([xKey])(data))
        // .xNice()
        // .xTicks(5)
        // .xTicks(6, d3.format(',d'))
        .xLabel(opts.xAxisLabel)
        .yDomain(fc.util.extent().pad(0.1).fields([yKey])(data))
        // .yOrient('left')
        // .yNice()
        .yTicks(7)
        // .yTickFormat((d) => '£' + d)
        .yLabel(opts.yAxisLabel)
        .margin({bottom: 40, right: 80, left: 15});

    // create the point series
    let point = fc.series.point()
        .size(44)
        .xValue(d => d[xKey])
        .yValue(d => d[yKey])
        .decorate(function(s) {
            s.enter()
                .style({
                    fill: '#eee',
                    stroke: '#aaa'
                });

            s.attr('d', function(d, i) {

                // check if current datum is same as selected uni
                if (d.university == ref.uniNames[ref.activeIndex]) {
                    // clear previous highlights
                    d3.selectAll('.chart-hgl-front').remove();
                    d3.selectAll('.chart-hgl-back').remove();
                    d3.select('#js-chart-note-null')
                        .text('');

                    // append background highlight
                    d3.select(this)
                        .append('circle')
                        .attr({
                            class: 'chart-hgl-back',
                            r: 20,
                            cx: 0,
                            cy: 0
                        })
                        .style({
                            fill: hglColour,
                            stroke: hglColour,
                            opacity: 0.2
                        });
                    // append foreground highlight
                    d3.select(this)
                        .append('circle')
                        .attr({
                            class: 'chart-hgl-front',
                            r: 4,
                            cx: 0,
                            cy: 0
                        })
                        .style({
                            fill: hglColour,
                            stroke: hglColour,
                            opacity: 1
                        })
                        .moveToFront();

                    // insure they sit correctly with other nodes
                    d3.selectAll('.chart-hgl-back')
                        .moveToBack();
                    d3.select(this)
                        .moveToFront();
                } 
                // don't show highlight if there is no value
                if (_.isNull(ref.data[ref.activeIndex][xKey])) {
                    // clear highlights
                    d3.selectAll('.chart-hgl-front').remove();
                    d3.selectAll('.chart-hgl-back').remove();
                    // provide the user with feedback on why no highlight
                    d3.select('#js-chart-note-null')
                        .style('border-left', '4px solid ' + opts.colour)
                        .style('padding-left', '10px')
                        .text('Data is not available to be represented on the chart for ' + ref.data[ref.activeIndex].university);
                }
            });
        });

    // create a crosshair tool
    let crosshair = fc.tool.crosshair();

    if (opts.snap == 'x') {
        crosshair.snap(fc.util.seriesPointSnapXOnly(point, data));
    } else {
        crosshair.snap(fc.util.seriesPointSnapYOnly(point, data));
    }

    crosshair
        // .xLabel(d => d.datum[xKey])
        // .yLabel(d => d.datum[yKey])
        .xLabel('')
        .yLabel('')
        .on('trackingstart', render)
        .on('trackingmove', render)
        .on('trackingend', render);

    let tooltip = fc.chart.tooltip()
        .items([
            [(d => d.datum['university'])],
            ['X:', (d => f(d.datum[xKey]))],
            ['Y:', (d => f(d.datum[yKey]))]
        ]);

    let tooltipLayout = fc.layout.label()
        .position([10, 10])
        .size([60, 60])
        .component(tooltip);

    // create an array which will hold the crosshair datapoint
    let crosshairData = [];

    // add it to the chart
    let multi = fc.series.multi()
        .series([point, crosshair, tooltipLayout])
        .mapping(function(series) {
            // console.log(this);
            switch (series) {
            case point:
                return data; // data
            case crosshair:
            case tooltipLayout:
                return crosshairData;
            }
        });

    chart.plotArea(multi);

    function render() {
        d3.select(opts.id)
            .datum(data)
            .call(chart);
    }
    render();

}



